import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/frontdoor/login.service';
import { RoleService } from '../../services/frontdoor/role.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  isAuthenticated = false;
  userImagePath: string | null = null; // New property for storing the user's image path
  userFirstname: string | null = null;   // For the user's first name
  userLastname: string | null = null;    // For the user's last name

  authSubscription!: Subscription;
  roleSubscription: Subscription | undefined;
  role: string | null = null;

  constructor(
    public loginService: LoginService, 
    public roleService: RoleService, 
    private router: Router
  ) {}

  ngOnInit(): void {
    // Subscribe to authentication state to know if user is logged in.
    this.authSubscription = this.loginService.authState$.subscribe(isAuth => {
      this.isAuthenticated = isAuth;
      if (isAuth) {
        // When authenticated, fetch the user's profile to get the imagePath.
        this.loginService.getProfile().subscribe((res: any) => {
          if (res.success && res.user && res.user.imagePath) {
            this.userImagePath = res.user.imagePath;
            this.userFirstname = res.user.firstname;
            this.userLastname = res.user.lastname;
          }
        });
      } else {
        this.userImagePath = null;
      }
    });

    // Subscribe to role observable so that the navbar always has the current role.
    this.roleSubscription = this.roleService.role$.subscribe(role => {
      this.role = role;
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks.
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe();
    }
  }

  onLogout() {
    // Call the logout endpoint
    this.loginService.logout().subscribe(() => {
      // The BehaviorSubject is set to false inside logout(),
      // so "isAuthenticated" will auto-update to false.
      this.router.navigate(['/login']);
    });
  }

  // Helper method returns the full path for the user image.
  // For development, we prepend "http://localhost:8000/".
  userImageFullPath(): string {
    if (this.userImagePath) {
      if (location.hostname === 'localhost') {
        return `http://localhost:8000/${this.userImagePath}`;
      } else {
        // Adjust this URL for production as needed.
        return `https://your-production-domain.com/${this.userImagePath}`;
      }
    }
    return '';
  }
}
